import { Skeleton, Stack } from '@mui/material';

const NotificationSkeleton = () => {
    return (
        <>
            <div className="pt-1 centerClass" style={{ width: '98%', marginTop: '20px' }}>
                <Stack spacing={3}>
                    <Skeleton variant="rounded" height={'82px'} />
                    <Skeleton variant="rounded" height={'82px'} />
                    <Skeleton variant="rounded" height={'82px'} />
                    <Skeleton variant="rounded" height={'82px'} />
                </Stack>
            </div>
        </>
    );
};

export default NotificationSkeleton;
